import { render } from "./Mybids.vue?vue&type=template&id=d5ae722c&scoped=true"
import script from "./Mybids.vue?vue&type=script&lang=js"
export * from "./Mybids.vue?vue&type=script&lang=js"

import "./Mybids.vue?vue&type=style&index=0&id=d5ae722c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d5ae722c"

export default script